"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
exports.AttachmentResponseStateRecord = immutable_1.Record({
    err: null,
    fileCount: 0,
    completedUploads: 0,
    files: null
});
/** This is a class that defines the structure of an attachment's state once a file has been uploaded  */
var AttachmentResponseState = /** @class */ (function (_super) {
    __extends(AttachmentResponseState, _super);
    function AttachmentResponseState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AttachmentResponseState;
}(exports.AttachmentResponseStateRecord));
exports.AttachmentResponseState = AttachmentResponseState;
/** Immutable Record structured in the format expected for a TimeElement response */
exports.TimeResponseStateRecord = immutable_1.Record({
    hour: "",
    minute: "",
    period: ""
});
/** Immutable time of day value */
var TimeResponseState = /** @class */ (function (_super) {
    __extends(TimeResponseState, _super);
    function TimeResponseState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TimeResponseState;
}(exports.TimeResponseStateRecord));
exports.TimeResponseState = TimeResponseState;
/** Immutable record for electronic signature store data. Contains default values. */
exports.ElectronicSignatureResponseStateRecord = immutable_1.Record({
    /* True if signing is in progress, false otherwise */
    signInProgress: false,
    /* ETO formatted coordinates (destination: ETO database) */
    etoCoords: immutable_1.List(),
    /* Image URL, obtained from html canvas. Use this for Apricot compatibility. */
    imageUrl: null,
    /* Default sign pad width. Used for scaling and element sizing. */
    signPadWidth: 100,
    /* Default sign pad height. Used for scaling and element sizing. */
    signPadHeight: 100
});
/** Immutable record for electronic signature store data. Contains type information. */
var ElectronicSignatureResponseState = /** @class */ (function (_super) {
    __extends(ElectronicSignatureResponseState, _super);
    function ElectronicSignatureResponseState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ElectronicSignatureResponseState;
}(exports.ElectronicSignatureResponseStateRecord));
exports.ElectronicSignatureResponseState = ElectronicSignatureResponseState;
var emailNotificationStatus;
(function (emailNotificationStatus) {
    /** this is the default if the notification has not been evaluated */
    emailNotificationStatus["notChecked"] = "email.not-checked";
    /** this is the status if an email notification has been sent successfully */
    emailNotificationStatus["sent"] = "email.sent";
    /** this is the status if the notification has been evaluated, but not was not sent */
    emailNotificationStatus["notSent"] = "email.not-sent";
    /** this is the status if an attempt was made to send the notification, but it failed for some reason */
    emailNotificationStatus["failure"] = "email.failed";
})(emailNotificationStatus = exports.emailNotificationStatus || (exports.emailNotificationStatus = {}));
/** Immutable record for electronic signature store data. Contains default values. */
exports.EmailNotificationRecord = immutable_1.Record({
    from: '',
    recipients: '',
    subject: '',
    body: '',
    status: emailNotificationStatus.notChecked,
    errorMessage: ''
});
/** Immutable record for electronic signature store data. Contains type information. */
var EmailNotificationState = /** @class */ (function (_super) {
    __extends(EmailNotificationState, _super);
    function EmailNotificationState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EmailNotificationState;
}(exports.EmailNotificationRecord));
exports.EmailNotificationState = EmailNotificationState;
//# sourceMappingURL=element-response-definition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/element-response-definition.js
// module id = 1147
// module chunks = 0